import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const ExpensesContext = React.createContext();


export const ExpensesProvider = ({ children }) => {


    const { btoken, stoken } = useUserContext();


    let data = { btoken, stoken };

    const {
        loading: expensesLoading, data: expensesData, fetchData: getExpensesData
    } = useFetch('/getExpenses', data);

    const {
        loading: expCategoryLoading, data: expCategoryData, fetchData: getExpCategoryData
    } = useFetch('/getExpenseCategories', data);








    const [showAddExpenses, setShowAddExpenses] = useState(false);
    const CloseAddExpenses = () => setShowAddExpenses(false);
    const openAddExpenses = () => setShowAddExpenses(true);

    const [showAddExpCategory, setShowAddExpCategory] = useState(false);
    const CloseAddExpCategory = () => setShowAddExpCategory(false);
    const openAddExpCategory = () => {
        CloseAddExpenses();
        setShowAddExpCategory(true);
    };



    return (
        <ExpensesContext.Provider value={{

            showAddExpenses, CloseAddExpenses, openAddExpenses,
            showAddExpCategory, CloseAddExpCategory, openAddExpCategory,


            expCategoryLoading, expCategoryData, getExpCategoryData,
            expensesLoading, expensesData, getExpensesData,


        }}>
            {children}
        </ExpensesContext.Provider>
    );
};

// make sure use
export const useExpensesContext = () => {
    return useContext(ExpensesContext);
};
